import { money } from '../format'
import type { ContentsItem } from '../types'

export function ContentsTable({ items }: { items: ContentsItem[] }) {
  return (
    <div className="contents-lines">
      {items.map((item) => (
        <div className="contents-line" key={item.categoryCode}>
          <div className="contents-line__title">
            <b>
              {item.quantity} × {item.name}
            </b>
            <strong>
              {money(item.unitValueMinor * item.quantity, item.currency)}
            </strong>
          </div>
          <p>{item.description}</p>
          <dl>
            <div>
              <dt>Contents weight</dt>
              <dd>{item.itemWeightGrams} g</dd>
            </div>
            <div>
              <dt>Value per unit</dt>
              <dd>{money(item.unitValueMinor, item.currency)}</dd>
            </div>
            <div>
              <dt>Origin</dt>
              <dd>{item.originCountryCode}</dd>
            </div>
            <div>
              <dt>HS code</dt>
              <dd>{item.hsCode || 'Not specified'}</dd>
            </div>
            {item.skuCode && <div><dt>Product SKU</dt><dd>{item.skuCode}</dd></div>}
            {item.manufacturerCode && <div><dt>Manufacturer code</dt><dd>{item.manufacturerCode}</dd></div>}
            {item.euExemptCategory && <div><dt>EU product identifiers</dt><dd>Declared exempt</dd></div>}
          </dl>
        </div>
      ))}
    </div>
  )
}
